import { useState, type PropsWithChildren, useCallback, useMemo } from "react";

import {
  HotelBookingContext,
  type HotelBookingContextValue,
} from "./HotelBookingContext";

export const HotelBookingContextProvider = ({
  children,
}: PropsWithChildren) => {
  const [data, setData] = useState<HotelBookingContextValue["data"]>(null);
  const [availabilityToken, setAvailabilityToken] = useState<string | null>(
    null,
  );
  const [promoCode, setPromoCode] = useState<string | null>(null);

  const resetBooking = useCallback(() => {
    setData(null);
    setAvailabilityToken(null);
    setPromoCode(null);
  }, []);

  const contextValue = useMemo(
    () => ({
      data,
      setData,
      availabilityToken,
      promoCode,
      setPromoCode,
      setAvailabilityToken,
      resetBooking,
    }),
    [availabilityToken, data, promoCode, resetBooking],
  );

  return (
    <HotelBookingContext.Provider value={contextValue}>
      {children}
    </HotelBookingContext.Provider>
  );
};
